export enum FinanceFilterEnum {
  point_code = 'point_code',
  created_date_from = 'created_date_from',
  created_date_to = 'created_date_to',
  displayed_currency = 'displayed_currency'
}

export enum CashFlowOperationTypeEnum {
  admin_transfer = 'admin_transfer',
  deposit = 'deposit',
  settle = 'settle',
  hold = 'hold',
  payout = 'payout',
  rolling = 'rolling',
  cancelled_payout = 'cancelled_payout'
}
